import React, { useState, useEffect } from "react";
import { Add, Remove } from "@mui/icons-material";
import medicalServices from "../../../Services/medicalServices";
import hospitalStructureService from "../../../Services/Hospitalstructureservice";
import billingService from "../../../Services/Billingservice";
import InvoicePrint from "../../../Components/InvoicePrint";
import { FaArrowLeftLong } from "react-icons/fa6";
import { FaArrowRightLong } from "react-icons/fa6";



const Toast = ({ message, type, onDone }) => {
  useEffect(() => {
    const t = setTimeout(onDone, 3000);
    return () => clearTimeout(t);
  }, [onDone]);

  const colors =
    type === "success"
      ? "bg-green-50 border-green-200 text-green-700"
      : "bg-red-50 border-red-200 text-red-700";

  return (
    <div
      className={`fixed bottom-6 right-6 z-50 flex items-center gap-2 px-4 py-3 rounded-xl border text-[13px] font-[500] shadow-lg ${colors}`}
    >
      <span>{type === "success" ? "✓" : "✕"}</span>
      <span>{message}</span>
    </div>
  );
};

const DischargedBanner = () => (
  <div className="mb-5 flex items-center gap-3 px-4 py-3 bg-green-50 border border-green-200 rounded-xl text-[13px] text-green-700 font-[500]">
    <span className="text-[16px]">✓</span>
    <span>
      This patient has been discharged. All fields are now{" "}
      <strong>read-only</strong>.
    </span>
  </div>
);


const AdmissionDetails = ({ admission: p, isDischargedState }) => {
  const fmt = (dateStr) =>
    dateStr
      ? new Date(dateStr).toLocaleDateString("en-GB", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })
      : "—";

  return (
    <div>
      {isDischargedState && <DischargedBanner />}
      <div className="sm:grid sm:grid-cols-3 grid grid-cols-2 gap-x-8 gap-y-4">
        <p className="text-[10px] uppercase tracking-[0.12em] font-[600] text-[#2F6DB4] mb-4 mt-0 col-span-full border-b border-gray-100 pb-1">
          Personal Information
        </p>
        <div className="flex flex-col gap-[2px]">
          <span className="text-[10px] uppercase tracking-wide text-gray-400 font-[500]">Full Name</span>
          <span className="text-[13px] text-gray-800 font-[500]">{p?.full_name || "—"}</span>
        </div>
        <div className="flex flex-col gap-[2px]">
          <span className="text-[10px] uppercase tracking-wide text-gray-400 font-[500]">Father / Husband Name</span>
          <span className="text-[13px] text-gray-800 font-[500]">{p?.father_husband_name || "—"}</span>
        </div>
        <div className="flex flex-col gap-[2px]">
          <span className="text-[10px] uppercase tracking-wide text-gray-400 font-[500]">Gender</span>
          <span className="text-[13px] text-gray-800 font-[500]">{p?.gender || "—"}</span>
        </div>
        <div className="flex flex-col gap-[2px]">
          <span className="text-[10px] uppercase tracking-wide text-gray-400 font-[500]">Date of Birth</span>
          <span className="text-[13px] text-gray-800 font-[500]">{fmt(p?.dOB)}</span>
        </div>
        <div className="flex flex-col gap-[2px]">
          <span className="text-[10px] uppercase tracking-wide text-gray-400 font-[500]">Age</span>
          <span className="text-[13px] text-gray-800 font-[500]">{p?.age || "—"}</span>
        </div>
        <div className="flex flex-col gap-[2px]">
          <span className="text-[10px] uppercase tracking-wide text-gray-400 font-[500]">Marital Status</span>
          <span className="text-[13px] text-gray-800 font-[500]">{p?.marital_status || "—"}</span>
        </div>
        <div className="flex flex-col gap-[2px]">
          <span className="text-[10px] uppercase tracking-wide text-gray-400 font-[500]">Occupation</span>
          <span className="text-[13px] text-gray-800 font-[500]">{p?.occupation || "—"}</span>
        </div>
        <div className="flex flex-col gap-[2px]">
          <span className="text-[10px] uppercase tracking-wide text-gray-400 font-[500]">Nationality</span>
          <span className="text-[13px] text-gray-800 font-[500]">{p?.nationality || "—"}</span>
        </div>
        <div className="flex flex-col gap-[2px]">
          <span className="text-[10px] uppercase tracking-wide text-gray-400 font-[500]">Blood Group</span>
          <span className="text-[13px] text-gray-800 font-[500]">{p?.blood_group || "—"}</span>
        </div>
        <div className="flex flex-col gap-[2px]">
          <span className="text-[10px] uppercase tracking-wide text-gray-400 font-[500]">CNIC</span>
          <span className="text-[13px] text-gray-800 font-[500]">{p?.CNIC || "—"}</span>
        </div>
      </div>

      <div className="sm:grid sm:grid-cols-3 grid grid-cols-2 gap-x-8 gap-y-4 mt-2">
        <p className="text-[10px] uppercase tracking-[0.12em] font-[600] text-[#2F6DB4] mb-4 mt-6 col-span-full border-b border-gray-100 pb-1">
          Contact Information
        </p>
        <div className="flex flex-col gap-[2px]">
          <span className="text-[10px] uppercase tracking-wide text-gray-400 font-[500]">Contact Number</span>
          <span className="text-[13px] text-gray-800 font-[500]">{p?.contact_number || "—"}</span>
        </div>
        <div className="flex flex-col gap-[2px] min-w-0">
          <span className="text-[10px] uppercase tracking-wide text-gray-400 font-[500]">Email</span>
          <span className="text-[13px] text-gray-800 font-[500] break-words">{p?.email || "—"}</span>
        </div>
        <div className="flex flex-col gap-[2px]">
          <span className="text-[10px] uppercase tracking-wide text-gray-400 font-[500]">Address</span>
          <span className="text-[13px] text-gray-800 font-[500]">{p?.address || "—"}</span>
        </div>
        <div className="flex flex-col gap-[2px]">
          <span className="text-[10px] uppercase tracking-wide text-gray-400 font-[500]">City</span>
          <span className="text-[13px] text-gray-800 font-[500]">{p?.city || "—"}</span>
        </div>
      </div>

      <div className="sm:grid sm:grid-cols-3 grid grid-cols-2 gap-x-8 gap-y-4 mt-2">
        <p className="text-[10px] uppercase tracking-[0.12em] font-[600] text-[#2F6DB4] mb-4 mt-6 col-span-full border-b border-gray-100 pb-1">
          Admission Details
        </p>
        <div className="flex flex-col gap-[2px]">
          <span className="text-[10px] uppercase tracking-wide text-gray-400 font-[500]">Checkup Date</span>
          <span className="text-[13px] text-gray-800 font-[500]">{p?.checkup_date || "—"}</span>
        </div>
        <div className="flex flex-col gap-[2px]">
          <span className="text-[10px] uppercase tracking-wide text-gray-400 font-[500]">Admission Type</span>
          <span className="text-[13px] text-gray-800 font-[500]">{p?.admission_type || "—"}</span>
        </div>
        <div className="flex flex-col gap-[2px]">
          <span className="text-[10px] uppercase tracking-wide text-gray-400 font-[500]">Department / Ward</span>
          <span className="text-[13px] text-gray-800 font-[500]">{p?.department_ward || "—"}</span>
        </div>
        <div className="flex flex-col gap-[2px]">
          <span className="text-[10px] uppercase tracking-wide text-gray-400 font-[500]">Doctor Assigned</span>
          <span className="text-[13px] text-gray-800 font-[500]">{p?.doctor_assigned || "—"}</span>
        </div>
        <div className="flex flex-col gap-[2px]">
          <span className="text-[10px] uppercase tracking-wide text-gray-400 font-[500]">Room Number</span>
          <span className="text-[13px] text-gray-800 font-[500]">{p?.room_number || "—"}</span>
        </div>
        <div className="flex flex-col gap-[2px]">
          <span className="text-[10px] uppercase tracking-wide text-gray-400 font-[500]">Bed Number</span>
          <span className="text-[13px] text-gray-800 font-[500]">{p?.bed_number || "—"}</span>
        </div>
        <div className="flex flex-col gap-[2px]">
          <span className="text-[10px] uppercase tracking-wide text-gray-400 font-[500]">Admission Date</span>
          <span className="text-[13px] text-gray-800 font-[500]">{p?.admission_date || "—"}</span>
        </div>
        <div className="flex flex-col gap-[2px]">
          <span className="text-[10px] uppercase tracking-wide text-gray-400 font-[500]">Admission Time</span>
          <span className="text-[13px] text-gray-800 font-[500]">{p?.admission_time || "—"}</span>
        </div>
        <div className="flex flex-col gap-[2px]">
          <span className="text-[10px] uppercase tracking-wide text-gray-400 font-[500]">Referred By</span>
          <span className="text-[13px] text-gray-800 font-[500]">{p?.referred_by || "—"}</span>
        </div>
        <div className="flex flex-col gap-[2px]">
          <span className="text-[10px] uppercase tracking-wide text-gray-400 font-[500]">Admission Reason</span>
          <span className="text-[13px] text-gray-800 font-[500]">{p?.admission_reason || "—"}</span>
        </div>
      </div>

      <div className="sm:grid sm:grid-cols-3 grid grid-cols-2 gap-x-8 gap-y-4 mt-2">
        <p className="text-[10px] uppercase tracking-[0.12em] font-[600] text-[#2F6DB4] mb-4 mt-6 col-span-full border-b border-gray-100 pb-1">
          Vitals
        </p>
        <div className="flex flex-col gap-[2px]">
          <span className="text-[10px] uppercase tracking-wide text-gray-400 font-[500]">Weight (kg)</span>
          <span className="text-[13px] text-gray-800 font-[500]">{p?.weight_kg || "—"}</span>
        </div>
        <div className="flex flex-col gap-[2px]">
          <span className="text-[10px] uppercase tracking-wide text-gray-400 font-[500]">Temperature (°C)</span>
          <span className="text-[13px] text-gray-800 font-[500]">{p?.temperature_c || "—"}</span>
        </div>
        <div className="flex flex-col gap-[2px]">
          <span className="text-[10px] uppercase tracking-wide text-gray-400 font-[500]">Blood Pressure</span>
          <span className="text-[13px] text-gray-800 font-[500]">{p?.blood_pressure || "—"}</span>
        </div>
        <div className="flex flex-col gap-[2px]">
          <span className="text-[10px] uppercase tracking-wide text-gray-400 font-[500]">Pulse Rate</span>
          <span className="text-[13px] text-gray-800 font-[500]">{p?.pulse_rate || "—"}</span>
        </div>
        <div className="flex flex-col gap-[2px]">
          <span className="text-[10px] uppercase tracking-wide text-gray-400 font-[500]">Blood Sugar</span>
          <span className="text-[13px] text-gray-800 font-[500]">{p?.blood_sugar || "—"}</span>
        </div>
      </div>

      <div className="sm:grid sm:grid-cols-3 grid grid-cols-2 gap-x-8 gap-y-4 mt-2">
        <p className="text-[10px] uppercase tracking-[0.12em] font-[600] text-[#2F6DB4] mb-4 mt-6 col-span-full border-b border-gray-100 pb-1">
          Medical History
        </p>
        <div className="flex flex-col gap-[2px]">
          <span className="text-[10px] uppercase tracking-wide text-gray-400 font-[500]">Allergies</span>
          <span className="text-[13px] text-gray-800 font-[500]">{p?.allergies || "—"}</span>
        </div>
        <div className="flex flex-col gap-[2px]">
          <span className="text-[10px] uppercase tracking-wide text-gray-400 font-[500]">Medical History</span>
          <span className="text-[13px] text-gray-800 font-[500]">{p?.medical_history || "—"}</span>
        </div>
        <div className="flex flex-col gap-[2px]">
          <span className="text-[10px] uppercase tracking-wide text-gray-400 font-[500]">Current Medications</span>
          <span className="text-[13px] text-gray-800 font-[500]">{p?.current_medications || "—"}</span>
        </div>
        <div className="flex flex-col gap-[2px]">
          <span className="text-[10px] uppercase tracking-wide text-gray-400 font-[500]">Previous Surgeries</span>
          <span className="text-[13px] text-gray-800 font-[500]">{p?.previous_surgeries || "—"}</span>
        </div>
      </div>

      <div className="sm:grid sm:grid-cols-3 grid grid-cols-2 gap-x-8 gap-y-4 mt-2">
        <p className="text-[10px] uppercase tracking-[0.12em] font-[600] text-[#2F6DB4] mb-4 mt-6 col-span-full border-b border-gray-100 pb-1">
          Guardian Information
        </p>
        <div className="flex flex-col gap-[2px]">
          <span className="text-[10px] uppercase tracking-wide text-gray-400 font-[500]">Guardian Name</span>
          <span className="text-[13px] text-gray-800 font-[500]">{p?.guardian_name || "—"}</span>
        </div>
        <div className="flex flex-col gap-[2px]">
          <span className="text-[10px] uppercase tracking-wide text-gray-400 font-[500]">Guardian CNIC</span>
          <span className="text-[13px] text-gray-800 font-[500]">{p?.guardian_CNIC || "—"}</span>
        </div>
        <div className="flex flex-col gap-[2px]">
          <span className="text-[10px] uppercase tracking-wide text-gray-400 font-[500]">Emergency Contact</span>
          <span className="text-[13px] text-gray-800 font-[500]">{p?.emergency_contact || "—"}</span>
        </div>
        <div className="flex flex-col gap-[2px]">
          <span className="text-[10px] uppercase tracking-wide text-gray-400 font-[500]">Relationship</span>
          <span className="text-[13px] text-gray-800 font-[500]">{p?.guardian_relationship || "—"}</span>
        </div>
      </div>
    </div>
  );
};


const SaleService = ({
  admissionId,
  onTotalChange,
  onSaved,
  showToast,
  isDischargedState,
}) => {
  const [rows, setRows] = useState([{ service_id: "", quantity: 1, unit_price: "" }]);
  const [servicesList, setServicesList] = useState([]);
  const [fetchingServices, setFetchingServices] = useState(true);
  const [fetchError, setFetchError] = useState(null);
  const [saving, setSaving] = useState(false);
  const [savedCharges, setSavedCharges] = useState([]);

  useEffect(() => {
    const load = async () => {
      try {
        setFetchingServices(true);
        const [servicesData, chargesData] = await Promise.all([
          medicalServices.fetchAll(),
          medicalServices.getChargesByAdmission(admissionId),
        ]);
        const list = Array.isArray(servicesData) ? servicesData : (servicesData.services ?? []);
        const charges = chargesData.charges ?? [];
        setServicesList(list);
        setSavedCharges(charges);
        onTotalChange(charges.reduce((s, c) => s + Number(c.total_charge), 0));
      } catch {
        setFetchError("Failed to load services.");
      } finally {
        setFetchingServices(false);
      }
    };
    load();
  }, [admissionId]);

  const calcRowsTotal = (r) =>
    r.reduce((s, row) => s + (Number(row.quantity) || 0) * (Number(row.unit_price) || 0), 0);

  const updateRows = (updated) => {
    setRows(updated);
    const savedTotal = savedCharges.reduce((s, c) => s + Number(c.total_charge), 0);
    onTotalChange(savedTotal + calcRowsTotal(updated));
  };

  const handleChange = (i, field, value) => {
    if (isDischargedState) return;
    const updated = [...rows];
    if (field === "service_id") {
      const id = Number(value);
      updated[i].service_id = id;
      const svc = servicesList.find((s) => s.id === id);
      if (svc) {
        updated[i].unit_price = svc.price;
        if (!updated[i].quantity) updated[i].quantity = 1;
      }
    } else if (field === "quantity") {
      updated[i].quantity = Math.max(1, Number(value));
    } else {
      updated[i][field] = value;
    }
    updateRows(updated);
  };

  const addRow = () => {
    if (isDischargedState) return;
    updateRows([...rows, { service_id: "", quantity: 1, unit_price: "" }]);
  };

  const removeRow = (i) => {
    if (isDischargedState) return;
    updateRows(rows.filter((_, idx) => idx !== i));
  };

  const handleSave = async () => {
    if (isDischargedState) return;
    const validRows = rows.filter(
      (r) => r.service_id && Number(r.quantity) > 0 && Number(r.unit_price) > 0
    );
    if (!validRows.length) {
      showToast("Please select at least one service before saving.", "error");
      return;
    }
    setSaving(true);
    try {
      await Promise.all(
        validRows.map((r) =>
          medicalServices.addServiceCharge({
            admission_id: admissionId,
            medical_service_id: r.service_id,
            quantity: Number(r.quantity),
            unit_price: Number(r.unit_price),
            discount_applied: 0,
            total_charge: Number(r.quantity) * Number(r.unit_price),
            service_datetime: new Date().toISOString().slice(0, 19).replace("T", " "),
            notes: r.notes || "",
          })
        )
      );
      const chargesData = await medicalServices.getChargesByAdmission(admissionId);
      const charges = chargesData.charges ?? [];
      setSavedCharges(charges);
      setRows([{ service_id: "", quantity: 1, unit_price: "" }]);
      onTotalChange(charges.reduce((s, c) => s + Number(c.total_charge), 0));
      showToast("Service charges saved successfully.", "success");
      onSaved();
    } catch {
      showToast("Failed to save service charges. Please try again.", "error");
    } finally {
      setSaving(false);
    }
  };

  const savedTotal = savedCharges.reduce((s, c) => s + Number(c.total_charge), 0);
  const grandTotal = savedTotal + calcRowsTotal(rows);

  if (fetchingServices)
    return <div className="py-12 text-center text-[13px] text-gray-400">Loading services…</div>;
  if (fetchError)
    return <div className="py-12 text-center text-[13px] text-red-400">{fetchError}</div>;

  return (
    <div>
      {isDischargedState && <DischargedBanner />}
      <p className="text-[10px] uppercase tracking-[0.12em] font-[600] text-[#2F6DB4] mb-4 mt-0 col-span-full border-b border-gray-100 pb-1">
        {isDischargedState ? "Service Charges (Read-Only)" : "Add Service Charges"}
      </p>

      {!isDischargedState && (
        <div className="hidden lg:grid grid-cols-12 gap-3 mb-2 px-1">
          <span className="col-span-5 text-[10px] uppercase tracking-wide font-[600] text-gray-400">Service</span>
          <span className="col-span-2 text-[10px] uppercase tracking-wide font-[600] text-gray-400">Quantity</span>
          <span className="col-span-2 text-[10px] uppercase tracking-wide font-[600] text-gray-400">Price (Rs.)</span>
          <span className="col-span-2 text-[10px] uppercase tracking-wide font-[600] text-gray-400">Notes</span>
          <span className="col-span-1" />
        </div>
      )}

      {!isDischargedState && (
        <div className="flex flex-col gap-3">
          {rows.map((row, i) => {
            const rowTotal = (Number(row.quantity) || 0) * (Number(row.unit_price) || 0);
            return (
              <div key={i} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-3 items-center rounded-xl px-4 py-3 border bg-gray-50 border-gray-100">
                <div className="lg:col-span-5">
                  <label className="lg:hidden text-[11px] text-gray-400">Service</label>
                  <select
                    value={row.service_id || ""}
                    onChange={(e) => handleChange(i, "service_id", e.target.value)}
                    disabled={isDischargedState}
                    className="w-full px-3 py-2 text-[13px] text-gray-800 bg-white border border-gray-200 rounded-lg outline-none"
                  >
                    <option value="" disabled>Select service</option>
                    {servicesList.map((s) => (
                      <option key={s.id} value={s.id}>{s.name}</option>
                    ))}
                  </select>
                </div>
                <div className="lg:col-span-2">
                  <label className="lg:hidden text-[11px] text-gray-400">Quantity</label>
                  <input
                    type="number" min="1" value={row.quantity}
                    onChange={(e) => handleChange(i, "quantity", e.target.value)}
                    className="w-full px-3 py-2 text-[13px] bg-white border border-gray-200 rounded-lg"
                  />
                </div>
                <div className="lg:col-span-2">
                  <label className="lg:hidden text-[11px] text-gray-400">Price</label>
                  <div className="relative cursor-not-allowed">
                    <span className="absolute left-3 top-1/2 -translate-y-1/2 text-[12px] text-gray-400">Rs.</span>
                    <input readOnly value={row.unit_price} placeholder="0"
                      className="w-full pl-8 pr-3 py-2 text-[13px] text-gray-600 bg-gray-100 border border-gray-200 rounded-lg cursor-not-allowed"
                    />
                  </div>
                </div>
                <div className="lg:col-span-2">
                  <label className="lg:hidden text-[11px] text-gray-400">Notes</label>
                  <input type="text" placeholder="Optional note" value={row.notes || ""}
                    onChange={(e) => handleChange(i, "notes", e.target.value)}
                    className="w-full px-3 py-2 text-[13px] text-gray-800 bg-white border border-gray-200 rounded-lg"
                  />
                </div>
                <div className="lg:col-span-1 flex flex-row lg:flex-col items-center gap-2">
                  {rowTotal > 0 && (
                    <span className="text-[11px] text-gray-500">Rs.{rowTotal.toLocaleString()}</span>
                  )}
                  {rows.length > 1 && !isDischargedState && (
                    <button type="button" onClick={() => removeRow(i)} className="text-red-500">
                      <Remove style={{ fontSize: 16 }} />
                    </button>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {!isDischargedState && (
        <button type="button" onClick={addRow}
          className="mt-3 flex items-center gap-1.5 text-[13px] text-gray-500 hover:text-[#2F6DB4]"
        >
          <Add style={{ fontSize: 16 }} /> Add another service
        </button>
      )}

      {!isDischargedState && (
        <div className="mt-5 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          {grandTotal > 0 && (
            <div className="bg-[#215187] text-white rounded-xl px-6 py-3 flex items-center gap-4">
              <span className="text-[11px] uppercase text-blue-200">Services Total</span>
              <span className="text-[17px] font-[600]">Rs. {grandTotal.toLocaleString()}</span>
            </div>
          )}
          <button type="button" onClick={handleSave} disabled={saving || isDischargedState}
            className="bg-[#2F6DB4] hover:bg-[#215187] text-white text-[13px] px-5 py-2 rounded-lg"
          >
            {saving ? "Saving…" : "Save Service Charges →"}
          </button>
        </div>
      )}

      {savedCharges.length > 0 && (
        <div className="mt-6 border border-gray-100 rounded-xl overflow-x-auto">
          <div className="bg-gray-50 px-4 py-2.5 border-b border-gray-100">
            <span className="text-[10px] uppercase tracking-widest font-[600] text-gray-400">
              Saved Charges ({savedCharges.length})
            </span>
          </div>
          <table className="min-w-[700px] w-full">
            <thead>
              <tr className="border-b border-gray-100">
                <th className="px-4 py-2 text-left text-[10px] text-gray-400">Service</th>
                <th className="px-4 py-2 text-left text-[10px] text-gray-400">Qty</th>
                <th className="px-4 py-2 text-left text-[10px] text-gray-400">Unit Price</th>
                <th className="px-4 py-2 text-left text-[10px] text-gray-400">Total</th>
                <th className="px-4 py-2 text-left text-[10px] text-gray-400">Date & Time</th>
                <th className="px-4 py-2 text-left text-[10px] text-gray-400">Notes</th>
              </tr>
            </thead>
            <tbody>
              {savedCharges.map((c, i) => (
                <tr key={i} className="border-b border-gray-50">
                  <td className="px-4 py-2 text-[13px]">{c.service_name}</td>
                  <td className="px-4 py-2 text-[13px]">{c.quantity}</td>
                  <td className="px-4 py-2 text-[13px]">Rs. {Number(c.unit_price).toLocaleString()}</td>
                  <td className="px-4 py-2 text-[13px]">Rs. {Number(c.total_charge).toLocaleString()}</td>
                  <td className="px-4 py-2 text-[13px]">{c.service_datetime?.slice(0, 16).replace("T", " ")}</td>
                  <td className="px-4 py-2 text-[13px]">{c.notes || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};



const buildLabel = (entry) => {
  if (entry.entry_type === "room") {
    const parts = [entry.room_type, entry.room_number].filter(Boolean);
    return parts.length ? `Room — ${parts.join(" · ")}` : "Room";
  }
  const parts = [entry.ward_name, entry.bed_number ? `Bed ${entry.bed_number}` : null].filter(Boolean);
  return parts.length ? `Ward — ${parts.join(" · ")}` : "Ward";
};

const HospitalStructure = ({
  admissionId,
  preselectedStructureId,
  onTotalChange,
  onSaved,
  showToast,
  isDischargedState,
}) => {
  const [rows, setRows] = useState([{ item_id: "", quantity: 1, unit_price: "", discount_pct: 0 }]);
  const [structureList, setStructureList] = useState([]);
  const [fetchingItems, setFetchingItems] = useState(true);
  const [fetchError, setFetchError] = useState(null);
  const [saving, setSaving] = useState(false);
  const [savedCharges, setSavedCharges] = useState([]);
  const [preselected, setPreselected] = useState(false);

  useEffect(() => {
    const load = async () => {
      try {
        setFetchingItems(true);
        const [structData, chargesData] = await Promise.all([
          hospitalStructureService.getAllIncludingOccupied(),
          hospitalStructureService.getRoomChargesByAdmission(admissionId),
        ]);
        const list = Array.isArray(structData)
          ? structData
          : (structData.structures ?? structData.data ?? structData.hospitalStructures ?? []);
        const charges = chargesData.charges ?? [];
        setStructureList(list);
        setSavedCharges(charges);
        onTotalChange(charges.reduce((s, c) => s + Number(c.total_charge), 0));
      } catch {
        setFetchError("Failed to load hospital structure data.");
      } finally {
        setFetchingItems(false);
      }
    };
    load();
  }, [admissionId]);

  useEffect(() => {
    if (preselected || fetchingItems || !preselectedStructureId || structureList.length === 0) return;
    const entry = structureList.find((e) => e.id === Number(preselectedStructureId));
    if (!entry) return;
    const autoRow = { item_id: entry.id, quantity: 1, unit_price: entry.rate_per_day, discount_pct: entry.discount_percent ?? 0 };
    setRows((prev) => {
      const firstIsBlank = !prev[0].item_id;
      return firstIsBlank ? [autoRow] : [...prev, autoRow];
    });
    setPreselected(true);
  }, [structureList, fetchingItems, preselectedStructureId, preselected]);

  const calcRowsTotal = (r) =>
    r.reduce((s, row) => {
      const raw = (Number(row.quantity) || 0) * (Number(row.unit_price) || 0);
      const disc = Math.round(raw * ((Number(row.discount_pct) || 0) / 100));
      return s + raw - disc;
    }, 0);

  const updateRows = (updated) => {
    setRows(updated);
    const savedTotal = savedCharges.reduce((s, c) => s + Number(c.total_charge), 0);
    onTotalChange(savedTotal + calcRowsTotal(updated));
  };

  const handleChange = (i, field, value) => {
    if (isDischargedState) return;
    const updated = [...rows];
    if (field === "item_id") {
      const id = Number(value);
      updated[i].item_id = id;
      const entry = structureList.find((h) => h.id === id);
      if (entry) {
        updated[i].unit_price = entry.rate_per_day;
        updated[i].discount_pct = entry.discount_percent ?? 0;
        if (!updated[i].quantity) updated[i].quantity = 1;
      }
    } else if (field === "quantity") {
      updated[i].quantity = Math.max(1, Number(value));
    } else {
      updated[i][field] = value;
    }
    updateRows(updated);
  };

  const addRow = () => {
    if (isDischargedState) return;
    updateRows([...rows, { item_id: "", quantity: 1, unit_price: "", discount_pct: 0 }]);
  };

  const removeRow = (i) => {
    if (isDischargedState) return;
    updateRows(rows.filter((_, idx) => idx !== i));
  };

  const handleSave = async () => {
    if (isDischargedState) return;
    const validRows = rows.filter((r) => r.item_id && Number(r.quantity) > 0 && Number(r.unit_price) > 0);
    if (!validRows.length) {
      showToast("Please select at least one room or ward before saving.", "error");
      return;
    }
    setSaving(true);
    try {
      await Promise.all(
        validRows.map((r) => {
          const ratePerDay = Number(r.unit_price);
          const days = Number(r.quantity);
          const discountPct = Number(r.discount_pct) || 0;
          const subtotal = ratePerDay * days;
          const discountAmt = Math.round(subtotal * (discountPct / 100));
          return hospitalStructureService.addRoomCharge({
            admission_id: admissionId,
            hospital_structure_id: r.item_id,
            charge_date: new Date().toISOString().slice(0, 10),
            rate_per_day: ratePerDay,
            discount_applied: discountAmt,
            total_charge: subtotal - discountAmt,
          });
        })
      );
      const chargesData = await hospitalStructureService.getRoomChargesByAdmission(admissionId);
      const charges = chargesData.charges ?? [];
      setSavedCharges(charges);
      setRows([{ item_id: "", quantity: 1, unit_price: "", discount_pct: 0 }]);
      setPreselected(true);
      onTotalChange(charges.reduce((s, c) => s + Number(c.total_charge), 0));
      showToast("Hospital charges saved successfully.", "success");
      onSaved();
    } catch {
      showToast("Failed to save hospital charges. Please try again.", "error");
    } finally {
      setSaving(false);
    }
  };

  const savedTotal = savedCharges.reduce((s, c) => s + Number(c.total_charge), 0);
  const grandTotal = savedTotal + calcRowsTotal(rows);

  if (fetchingItems)
    return <div className="py-12 text-center text-[13px] text-gray-400">Loading hospital structure…</div>;
  if (fetchError)
    return <div className="py-12 text-center text-[13px] text-red-400">{fetchError}</div>;

  const rooms = structureList.filter((e) => e.entry_type === "room");
  const wards = structureList.filter((e) => e.entry_type === "ward");

  return (
    <div>
      {isDischargedState && <DischargedBanner />}
      <p className="text-[10px] uppercase tracking-[0.12em] font-[600] text-[#2F6DB4] mb-4 border-b border-gray-100 pb-1">
        {isDischargedState ? "Hospital Charges (Read-Only)" : "Add Hospital Charges"}
      </p>

      {!isDischargedState && preselected && rows.some((r) => r.item_id === Number(preselectedStructureId)) && (
        <div className="mb-4 flex items-center gap-2 px-3 py-2 bg-blue-50 border border-blue-100 rounded-lg text-[12px] text-blue-700">
          <span>Room / ward auto-selected from the admission form. Adjust days if needed, then save.</span>
        </div>
      )}

      {!isDischargedState && (
        <div className="hidden lg:grid grid-cols-12 gap-3 mb-2 px-1">
          <span className="col-span-5 text-[10px] uppercase text-gray-400">Room / Ward</span>
          <span className="col-span-2 text-[10px] uppercase text-gray-400">Days</span>
          <span className="col-span-2 text-[10px] uppercase text-gray-400">Rate/Day (Rs.)</span>
          <span className="col-span-2 text-[10px] uppercase text-gray-400">Discount %</span>
          <span className="col-span-1"></span>
        </div>
      )}

      {!isDischargedState && (
        <div className="flex flex-col gap-3">
          {rows.map((row, i) => {
            const rawTotal = (Number(row.quantity) || 0) * (Number(row.unit_price) || 0);
            const discAmt = Math.round(rawTotal * ((Number(row.discount_pct) || 0) / 100));
            const rowTotal = rawTotal - discAmt;
            const isAutoRow = i === 0 && row.item_id === Number(preselectedStructureId) && preselected;
            return (
              <div key={i} className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-3 rounded-xl px-4 py-3 border ${isAutoRow ? "bg-blue-50 border-blue-200" : "bg-gray-50 border-gray-100"}`}>
                <div className="lg:col-span-5">
                  <label className="lg:hidden text-[11px] text-gray-400">Room / Ward</label>
                  <select value={row.item_id || ""} onChange={(e) => handleChange(i, "item_id", e.target.value)}
                    className="w-full px-3 py-2 text-[13px] bg-white border border-gray-200 rounded-lg"
                  >
                    <option value="" disabled>Select room / ward</option>
                    {rooms.length > 0 && (
                      <optgroup label="Rooms">
                        {rooms.map((h) => <option key={h.id} value={h.id}>{buildLabel(h)}</option>)}
                      </optgroup>
                    )}
                    {wards.length > 0 && (
                      <optgroup label="Wards">
                        {wards.map((h) => <option key={h.id} value={h.id}>{buildLabel(h)}</option>)}
                      </optgroup>
                    )}
                  </select>
                </div>
                <div className="lg:col-span-2">
                  <label className="lg:hidden text-[11px] text-gray-400">Days</label>
                  <input type="number" min="1" value={row.quantity}
                    onChange={(e) => handleChange(i, "quantity", e.target.value)}
                    className="w-full px-3 py-2 text-[13px] border border-gray-200 rounded-lg"
                  />
                </div>
                <div className="lg:col-span-2">
                  <label className="lg:hidden text-[11px] text-gray-400">Rate / Day</label>
                  <div className="relative">
                    <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-[12px]">Rs.</span>
                    <input readOnly value={row.unit_price}
                      className="w-full pl-8 pr-3 py-2 text-[13px] bg-gray-100 border border-gray-200 rounded-lg"
                    />
                  </div>
                </div>
                <div className="lg:col-span-2">
                  <label className="lg:hidden text-[11px] text-gray-400">Discount %</label>
                  <div className="relative">
                    <input readOnly value={row.discount_pct ?? ""}
                      className="w-full px-3 pr-6 py-2 text-[13px] bg-gray-100 border border-gray-200 rounded-lg"
                    />
                    <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 text-[12px]">%</span>
                  </div>
                </div>
                <div className="lg:col-span-1 flex items-center gap-2">
                  {rowTotal > 0 && (
                    <span className="text-[12px] text-gray-500">Rs.{rowTotal.toLocaleString()}</span>
                  )}
                  {rows.length > 1 && (
                    <button type="button" onClick={() => removeRow(i)} className="text-red-500">
                      <Remove style={{ fontSize: 16 }} />
                    </button>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}

      {!isDischargedState && (
        <div className="mt-5 flex flex-col sm:flex-row gap-4 justify-between">
          {grandTotal > 0 && (
            <div className="bg-[#215187] text-white rounded-xl px-6 py-3 flex gap-4">
              <span className="text-[11px] uppercase text-blue-200">Hospital Total</span>
              <span className="text-[17px] font-[600]">Rs. {grandTotal.toLocaleString()}</span>
            </div>
          )}
          <button type="button" onClick={handleSave} disabled={saving || isDischargedState}
            className="bg-[#2F6DB4] hover:bg-[#215187] text-white text-[13px] px-5 py-2 rounded-lg"
          >
            {saving ? "Saving…" : "Save Hospital Charges →"}
          </button>
        </div>
      )}

      {savedCharges.length > 0 && (
        <div className="mt-6 border border-gray-100 rounded-xl overflow-x-auto">
          <div className="bg-gray-50 px-4 py-2 border-b border-gray-100">
            <span className="text-[10px] uppercase text-gray-400">Saved Charges ({savedCharges.length})</span>
          </div>
          <table className="min-w-[600px] w-full">
            <thead>
              <tr className="border-b border-gray-100">
                <th className="px-4 py-2 text-left text-[10px] text-gray-400">Room / Ward</th>
                <th className="px-4 py-2 text-left text-[10px] text-gray-400">Date</th>
                <th className="px-4 py-2 text-left text-[10px] text-gray-400">Rate/Day</th>
                <th className="px-4 py-2 text-left text-[10px] text-gray-400">Discount</th>
                <th className="px-4 py-2 text-left text-[10px] text-gray-400">Total</th>
              </tr>
            </thead>
            <tbody>
              {savedCharges.map((c, i) => (
                <tr key={i} className="border-b border-gray-50">
                  <td className="px-4 py-2 text-[13px]">{c.room_name}</td>
                  <td className="px-4 py-2 text-[13px]">{c.charge_date?.slice(0, 10)}</td>
                  <td className="px-4 py-2 text-[13px]">Rs. {Number(c.rate_per_day).toLocaleString()}</td>
                  <td className="px-4 py-2 text-[13px]">Rs. {Number(c.discount_applied).toLocaleString()}</td>
                  <td className="px-4 py-2 text-[13px]">Rs. {Number(c.total_charge).toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};



const TotalBilling = ({ admissionId, hospitalStructureId, refreshKey, onDischarged }) => {
  const [billData, setBillData]           = useState(null);
  const [loading, setLoading]             = useState(true);
  const [fetchError, setFetchError]       = useState(null);
  const [discount, setDiscount]           = useState(0);
  const [paying, setPaying]               = useState(false);

  const [paid, setPaid]                   = useState(false);
  const [payMethod, setPayMethod]         = useState("cash");
  const [invoiceNumber, setInvoiceNumber] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        setFetchError(null);

        
        const data = await billingService.getTotal(admissionId);
        setBillData(data);

        
        const invoice = await billingService.getInvoice(admissionId);
        if (invoice?.invoice_number) {
          setInvoiceNumber(invoice.invoice_number);
          setPaid(true);
        
          if (invoice.discount != null) setDiscount(invoice.discount);
          if (invoice.payment_method)  setPayMethod(invoice.payment_method);
        }
      } catch {
        setFetchError("Failed to load billing data.");
      } finally {
        setLoading(false);
      }
    };

    if (admissionId) load();
  }, [admissionId, refreshKey]);

  if (loading)
    return <div className="py-12 text-center text-[13px] text-gray-400">Loading billing summary…</div>;
  if (fetchError)
    return <div className="py-12 text-center text-[13px] text-red-400">{fetchError}</div>;

  const serviceCharges = billData?.service_charges ?? [];
  const roomCharges    = billData?.room_charges    ?? [];
  const saleTotal      = Number(billData?.service_total) || 0;
  const hospitalTotal  = Number(billData?.room_total)    || 0;
  const subtotal       = saleTotal + hospitalTotal;
  const discountAmt    = Math.min(Number(discount) || 0, subtotal);
  const grandTotal     = subtotal - discountAmt;

  const handleConfirm = async () => {
    setPaying(true);
    try {
      const result = await billingService.confirmDischarge({
        admission_id:   admissionId,
        subtotal:       subtotal,
        discount:       discountAmt,
        grand_total:    grandTotal,
        payment_method: payMethod,
      });

   
      if (result?.invoice_number) {
        setInvoiceNumber(result.invoice_number);
      }

      if (hospitalStructureId) {
        try {
          await hospitalStructureService.updateStatus(hospitalStructureId, 0);
        } catch (err) {
          console.error("Failed to release room status on discharge:", err);
        }
      }

      setPaid(true);
      if (onDischarged) onDischarged();

      setTimeout(() => window.print(), 300);
    } catch (err) {
      console.error("Discharge error:", err);
      alert("Failed to confirm discharge. Please try again.");
    } finally {
      setPaying(false);
    }
  };

  return (
    <div className="space-y-5">
      <InvoicePrint
        admissionId={admissionId}
        invoiceNumber={invoiceNumber}
        billData={billData}
        serviceCharges={serviceCharges}
        roomCharges={roomCharges}
        saleTotal={saleTotal}
        hospitalTotal={hospitalTotal}
        subtotal={subtotal}
        discountAmt={discountAmt}
        grandTotal={grandTotal}
        payMethod={payMethod}
      />

      {paid && (
        <div className="flex items-start sm:items-center gap-3 px-3 sm:px-4 py-3 bg-green-50 border border-green-200 rounded-xl text-[12px] sm:text-[13px] text-green-700 font-[500]">
          <span className="text-[16px]">✓</span>
          <div className="flex flex-col gap-0.5">
            <span>Payment made successfully. This patient has been discharged.</span>
            {invoiceNumber && (
              <span className="text-[12px] text-green-600">
                Invoice: <strong>{invoiceNumber}</strong>
              </span>
            )}
          </div>
        </div>
      )}

      <p className="text-[10px] sm:text-[11px] uppercase tracking-[0.12em] font-[600] text-[#2F6DB4] border-b border-gray-100 pb-2">
        Billing Summary
      </p>

      <div className="border border-gray-100 rounded-xl overflow-hidden bg-white">
        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-1 px-3 sm:px-5 py-3 border-b bg-gray-50">
          <span className="text-[12px] sm:text-[13px] text-gray-500">Subtotal</span>
          <span className="text-[13px] font-[600] text-gray-800">Rs. {subtotal.toLocaleString()}</span>
        </div>

        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2 px-3 sm:px-5 py-3 border-b">
          <span className="text-[12px] sm:text-[13px] text-gray-500">Payment Method</span>
          {paid ? (
            <span className="w-full sm:w-auto px-3 py-2 text-[13px] text-gray-700 bg-gray-100 border border-gray-200 rounded-lg capitalize text-center sm:text-left">
              {payMethod.replace("_", " ")}
            </span>
          ) : (
            <select value={payMethod} onChange={(e) => setPayMethod(e.target.value)}
              className="w-full sm:w-52 px-3 py-2 text-[13px] bg-white border border-gray-200 rounded-lg outline-none focus:border-[#2F6DB4] focus:ring-2 focus:ring-[#2F6DB4]/10"
            >
              <option value="cash">Cash</option>
              <option value="bank_transfer">Bank Transfer</option>
              <option value="insurance">Insurance</option>
              <option value="part_payment">Part Payment</option>
            </select>
          )}
        </div>

        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-2 px-3 sm:px-5 py-3 border-b">
          <span className="text-[12px] sm:text-[13px] text-gray-500">Discount (Rs.)</span>
          {paid ? (
            <span className="w-full sm:w-36 px-3 py-2 text-[13px] text-right text-gray-700 bg-gray-100 border border-gray-200 rounded-lg">
              {Number(discount).toLocaleString()}
            </span>
          ) : (
            <input type="number" min="0" max={subtotal} value={discount}
              onChange={(e) => setDiscount(e.target.value)}
              className="w-full sm:w-36 px-3 py-2 text-[13px] text-right bg-white border border-gray-200 rounded-lg outline-none focus:border-[#2F6DB4] focus:ring-2 focus:ring-[#2F6DB4]/10"
            />
          )}
        </div>

        {discountAmt > 0 && (
          <div className="flex justify-between px-3 sm:px-5 py-3 bg-green-50 border-b">
            <span className="text-[12px] sm:text-[13px] text-green-700">Discount Applied</span>
            <span className="text-[12px] sm:text-[13px] font-[600] text-green-700">
              − Rs. {discountAmt.toLocaleString()}
            </span>
          </div>
        )}

        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center gap-1 px-3 sm:px-5 py-4 bg-[#215187]">
          <span className="text-[12px] sm:text-[13px] uppercase tracking-wide font-[600] text-blue-200">Grand Total</span>
          <span className="text-[18px] sm:text-[22px] font-[700] text-white">Rs. {grandTotal.toLocaleString()}</span>
        </div>
      </div>

      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div className="flex items-center gap-2">
          {paid ? (
            <>
              <span className="w-2 h-2 rounded-full bg-green-400" />
              <span className="text-[11px] sm:text-[12px] text-green-600 font-[500]">
                Discharged & payment confirmed
              </span>
            </>
          ) : (
            <>
              <span className="w-2 h-2 rounded-full bg-amber-400" />
              <span className="text-[11px] sm:text-[12px] text-gray-400">Payment pending</span>
            </>
          )}
        </div>

        <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
          {paid && (
            <button onClick={() => window.print()}
              className="w-full sm:w-auto text-[13px] font-[500] text-gray-500 hover:text-gray-700 px-4 py-2 border border-gray-200 rounded-lg"
            >
              Print Invoice
            </button>
          )}
          {!paid && (
            <button onClick={handleConfirm} disabled={paying || grandTotal === 0}
              className="w-full sm:w-auto bg-[#2F6DB4] hover:bg-[#215187] disabled:opacity-50 text-white text-[13px] font-[500] px-5 py-2 rounded-lg transition-colors"
            >
              {paying ? "Processing…" : "Confirm & Discharge →"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};



const AdmissionTabs = ({ admission }) => {
  const [activeTab, setActiveTab]         = useState("admission");
  const [saleTotal, setSaleTotal]         = useState(0);
  const [hospitalTotal, setHospitalTotal] = useState(0);
  const [billingKey, setBillingKey]       = useState(0);
  const [toast, setToast]                 = useState(null);

  
  const [isDischargedState, setIsDischargedState] = useState(false);

 
  useEffect(() => {
    const checkDischarge = async () => {
      if (!admission?.id) return;
      try {
        const invoice = await billingService.getInvoice(admission.id);
        if (invoice?.invoice_number) {
          setIsDischargedState(true);
        }
      } catch {
       
      }
    };
    checkDischarge();
  }, [admission?.id]);

  const billingGrand = saleTotal + hospitalTotal;

  const showToast = (message, type = "success") => setToast({ message, type });

  const handleSaved = () => {
    setBillingKey((k) => k + 1);
    setActiveTab("billing");
  };

 
  const handleDischarged = () => {
    setIsDischargedState(true);
  };

  const tabOrder = ["admission", "sale", "hospital", "billing"];
  const currentIndex = tabOrder.indexOf(activeTab);
  const goToPrev = () => { if (currentIndex > 0) setActiveTab(tabOrder[currentIndex - 1]); };
  const goToNext = () => { if (currentIndex < tabOrder.length - 1) setActiveTab(tabOrder[currentIndex + 1]); };

  return (
    <div className="w-full">
      {toast && (
        <Toast message={toast.message} type={toast.type} onDone={() => setToast(null)} />
      )}

      <div className="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden">
        <div className="bg-[#215187] px-8 py-5 flex items-center justify-between">
          <div>
            <h1 className="text-white text-[18px] font-[500] tracking-tight">
              {admission?.full_name || "Patient Admission"}
            </h1>
            <div className="flex items-center gap-3 mt-0.5">
              <p className="text-blue-300 text-[12px]">ID: {admission?.id || "—"}</p>
              {isDischargedState && (
                <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full bg-green-500/20 text-green-300 text-[10px] font-[600] uppercase tracking-wide">
                  ✓ Discharged
                </span>
              )}
            </div>
          </div>
          {billingGrand > 0 && (
            <div className="text-right">
              <p className="text-blue-300 text-[10px] uppercase tracking-widest">Total Due</p>
              <p className="text-white text-[20px] font-[600]">Rs. {billingGrand.toLocaleString()}</p>
            </div>
          )}
        </div>

        <div className="border-b border-gray-100 bg-gray-50/60 grid grid-cols-4">
          <button onClick={() => setActiveTab("admission")}
            className={`relative flex-1 px-4 py-3.5 text-[12px] font-[500] tracking-wide transition-colors
              ${activeTab === "admission" ? "text-[#215187] bg-white border-b-2 border-[#215187]" : "text-gray-400 hover:text-gray-600 hover:bg-gray-50 border-b-2 border-transparent"}`}
          >
            Admission Details
          </button>

          <button
            onClick={() => !isDischargedState && setActiveTab("sale")}
            disabled={isDischargedState}
            title={isDischargedState ? "Patient discharged — read-only" : undefined}
            className={`relative flex-1 px-4 py-3.5 text-[12px] font-[500] tracking-wide transition-colors
              ${activeTab === "sale" ? "text-[#215187] bg-white border-b-2 border-[#215187]"
                : isDischargedState ? "text-gray-300 cursor-not-allowed border-b-2 border-transparent"
                : "text-gray-400 hover:text-gray-600 hover:bg-gray-50 border-b-2 border-transparent"}`}
          >
            Sale Service
            {isDischargedState && <span className="ml-1 text-[9px] text-gray-300">🔒</span>}
          </button>

          <button
            onClick={() => !isDischargedState && setActiveTab("hospital")}
            disabled={isDischargedState}
            title={isDischargedState ? "Patient discharged — read-only" : undefined}
            className={`relative flex-1 px-4 py-3.5 text-[12px] font-[500] tracking-wide transition-colors
              ${activeTab === "hospital" ? "text-[#215187] bg-white border-b-2 border-[#215187]"
                : isDischargedState ? "text-gray-300 cursor-not-allowed border-b-2 border-transparent"
                : "text-gray-400 hover:text-gray-600 hover:bg-gray-50 border-b-2 border-transparent"}`}
          >
            Hospital Structure
            {isDischargedState && <span className="ml-1 text-[9px] text-gray-300">🔒</span>}
          </button>

          <button onClick={() => setActiveTab("billing")}
            className={`relative flex-1 px-4 py-3.5 text-[12px] font-[500] tracking-wide transition-colors
              ${activeTab === "billing" ? "text-[#215187] bg-white border-b-2 border-[#215187]" : "text-gray-400 hover:text-gray-600 hover:bg-gray-50 border-b-2 border-transparent"}`}
          >
            Total Billing
          </button>
        </div>

        <div className="px-8 py-6">
          {activeTab === "admission" && (
            <AdmissionDetails admission={admission} isDischargedState={isDischargedState} />
          )}
          {activeTab === "sale" && (
            <SaleService
              admissionId={admission?.id}
              onTotalChange={setSaleTotal}
              onSaved={handleSaved}
              showToast={showToast}
              isDischargedState={isDischargedState}
            />
          )}
          {activeTab === "hospital" && (
            <HospitalStructure
              admissionId={admission?.id}
              preselectedStructureId={admission?.hospital_structure_id ?? null}
              onTotalChange={setHospitalTotal}
              onSaved={handleSaved}
              showToast={showToast}
              isDischargedState={isDischargedState}
            />
          )}
          {activeTab === "billing" && (
            <TotalBilling
              admissionId={admission?.id}
              hospitalStructureId={admission?.hospital_structure_id ?? null}
              refreshKey={billingKey}
              onDischarged={handleDischarged}
            />
          )}
        </div>

        <div className="hidden md:flex border-t border-gray-100 px-8 py-4 items-center justify-between bg-gray-50/40">
          <button onClick={goToPrev} disabled={currentIndex === 0}
            className="text-[13px] font-[500] text-gray-400 hover:text-gray-600 disabled:opacity-30 transition-colors flex items-center gap-1"
          >
            <FaArrowLeftLong /> Previous
          </button>
          <div className="flex items-center gap-2">
            {tabOrder.map((tab) => (
              <button key={tab}
                onClick={() => {
                  if (isDischargedState && (tab === "sale" || tab === "hospital")) return;
                  setActiveTab(tab);
                }}
                disabled={isDischargedState && (tab === "sale" || tab === "hospital")}
                className={`transition-all rounded-full ${
                  activeTab === tab ? "w-6 h-2 bg-[#215187]"
                  : isDischargedState && (tab === "sale" || tab === "hospital")
                    ? "w-2 h-2 bg-gray-100 cursor-not-allowed"
                    : "w-2 h-2 bg-gray-200 hover:bg-gray-300"
                }`}
              />
            ))}
          </div>
          <button onClick={goToNext}
            disabled={
              currentIndex === tabOrder.length - 1 ||
              (isDischargedState && (tabOrder[currentIndex + 1] === "sale" || tabOrder[currentIndex + 1] === "hospital"))
            }
            className="text-[13px] font-[500] text-[#2F6DB4] hover:text-[#215187] disabled:opacity-30 transition-colors flex items-center gap-1"
          >
            Next <FaArrowRightLong />
          </button>
        </div>
      </div>
    </div>
  );
};

export default AdmissionTabs;